import { render, staticRenderFns } from "./AdminActionExtraFieldSetForm.vue?vue&type=template&id=b6ebc388&"
import script from "./AdminActionExtraFieldSetForm.vue?vue&type=script&lang=js&"
export * from "./AdminActionExtraFieldSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports